module.exports = {
	"id": "YT",
	"name": "Mayotte",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.04122,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.02061,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.00687,
			"27": null,
			"28": 0.00687,
			"29": null,
			"30": null,
			"31": 0.00687,
			"32": 0.01374,
			"33": 0.01374,
			"34": 0.00687,
			"35": 0.04809,
			"36": 0.06183,
			"37": null,
			"38": 0.00687,
			"39": 0.01374,
			"40": 0.06183,
			"41": null,
			"42": 0.01374,
			"43": 0.29541,
			"44": 0.05496,
			"45": 0.04809,
			"46": 0.04122,
			"47": 0.08931,
			"48": 0.32976,
			"49": 0.62517,
			"50": 0.16488,
			"51": 0.54273,
			"52": 0.42594,
			"53": 26.5182,
			"54": 7.15854,
			"55": 0.03435,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": 0.00687,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.00687,
			"13": 0.01374,
			"14": null,
			"15": null,
			"16": 0.1374,
			"17": 0.24045,
			"18": null,
			"19": null,
			"20": 0.01374,
			"21": null,
			"22": null,
			"23": 0.02748,
			"24": 0.01374,
			"25": null,
			"26": 0.01374,
			"27": null,
			"28": 0.01374,
			"29": null,
			"30": 0.01374,
			"31": 0.01374,
			"32": 0.19236,
			"33": 0.00687,
			"34": 0.16488,
			"35": 0.06183,
			"36": 0.10992,
			"37": 0.03435,
			"38": 0.2748,
			"39": 0.01374,
			"40": 0.04122,
			"41": 0.11679,
			"42": 0.18549,
			"43": 0.14427,
			"44": 0.15114,
			"45": 0.17175,
			"46": 0.15801,
			"47": 0.98928,
			"48": 0.67326,
			"49": 11.01948,
			"50": 0.02748,
			"51": null,
			"52": null,
			"3.5": 0.00687,
			"3.6": 0.01374
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.00687,
			"37": 0.04809,
			"38": null,
			"39": 0.01374,
			"40": 1.52514,
			"41": 0.1374,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.00687,
			"6": null,
			"7": 0.01374,
			"8": 0.02748,
			"9": 0.04122,
			"10": 1.86177,
			"3.1": null,
			"3.2": null,
			"5.1": 0.00687,
			"6.1": 0.0687,
			"7.1": null,
			"9.1": 0.51525
		},
		"ios_saf": {
			"8": 0,
			"10": 1.58334737719,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0426693796836,
			"8.1-8.4": 0.0788298709409,
			"9.0-9.2": 0.0376069109076,
			"9.3": 0.573746461282
		},
		"android": {
			"3": 0,
			"4": 0.0490285788114,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00612857235142,
			"4.1": 0.176853087855,
			"4.2-4.3": 0.442132719638,
			"4.4": 1.01384096899,
			"4.4.3-4.4.4": 1.02259607235
		},
		"ie": {
			"6": null,
			"7": 0.02748,
			"8": 0.11679,
			"9": 0.0687,
			"10": 0.15801,
			"11": 2.18466,
			"5.5": null
		},
		"op_mob": {
			"0": 0.11871919377,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0032977553825
		},
		"edge": {
			"12": 0.42594,
			"13": 0.81753,
			"14": 1.94421
		},
		"ie_mob": {
			"10": 0.147506760563,
			"11": 0.600563239437
		},
		"bb": {
			"7": 0.010955,
			"10": null
		},
		"samsung": {
			"0": 2.6292
		},
		"and_uc": {
			"0": 0.31613
		},
		"op_mini": {
			"0": 1.59948305085
		},
		"and_chr": {
			"0": 26.29068
		},
		"and_ff": {
			"0": 0.01565
		}
	},
	"total": 98.499655
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/YT.json
 ** module id = 685
 ** module chunks = 0
 **/